var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson2 = function SvgPerson2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.491,
    d: "M19.799 24.021v3.323l-16.55-9.556v-3.324q0-1.008.452-1.594.226-.29.526-.442h.003q.297-.147.672-.155 1.606.007 3.26.502 1.655.497 3.362 1.48a22.7 22.7 0 0 1 3.363 2.403 31.4 31.4 0 0 1 3.259 3.261 7.2 7.2 0 0 1 1.135 1.833q.035.074.066.152.453 1.109.452 2.117M15.663 10.711q0 .344-.037.646-.176 1.434-1.179 2.005-1.216.693-2.923-.293c-1.063-.614-1.987-1.555-2.763-2.82l-.04-.058-.12-.204Q7.386 7.89 7.386 5.932q0-1.96 1.215-2.65l.192-.096q1.157-.524 2.731.388.419.24.808.55 1.197.948 2.115 2.53 1.016 1.752 1.181 3.409.036.324.035.648"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.491,
    d: "M20.575 8.255q0 1.958-1.216 2.65l-.191.096-2.216 1.108-2.505 1.253q1.002-.571 1.179-2.005.037-.301.037-.645.001-.325-.034-.649-.166-1.656-1.182-3.409-.917-1.582-2.115-2.53a6.4 6.4 0 0 0-.808-.55q-1.573-.911-2.731-.388l4.72-2.36q1.217-.696 2.923.292 1.708.984 2.923 3.08 1.216 2.098 1.216 4.057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.491,
    d: "M24.711 21.565v3.323L19.8 27.344v-3.323q0-1.009-.452-2.117-.032-.078-.066-.152a7.2 7.2 0 0 0-1.135-1.833 31.4 31.4 0 0 0-3.26-3.262 22.6 22.6 0 0 0-3.362-2.402q-1.707-.984-3.362-1.48a11.5 11.5 0 0 0-3.26-.502q-.375.008-.673.155l4.493-2.238q.017.03.039.06c.776 1.264 1.7 2.205 2.763 2.819q1.707.986 2.923.292l2.505-1.252Q18.396 13 19.8 14.2a31.4 31.4 0 0 1 3.26 3.262 7.3 7.3 0 0 1 1.2 1.985q.453 1.108.452 2.117"
  })));
};
export default SvgPerson2;